import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { querySnapshotToArray, TDR } from 'tdr-common';

export function useRestaurantTaxPolicies(restaurant: Partial<TDR.Restaurant>) {
	const query = useQuery({
		queryKey: ['restaurantTaxPolicies', restaurant.taxes],
		queryFn: () => getRestaurantTaxPolicies(restaurant.taxes),
		enabled: !!restaurant && !!restaurant.taxes && Array.isArray(restaurant.taxes) && restaurant.taxes.length > 0
	});
	return query;
}

export async function getRestaurantTaxPolicies(restaurantTaxes: string[]): Promise<TDR.PricingPolicy[]> {
	try {
		// Return empty array if restaurant has no taxes defined
		if (!restaurantTaxes || restaurantTaxes.length === 0) {
			return [];
		}

		const db = getFirestore();
		const q = query(collection(db, 'PricingPolicies'), where('tax', 'in', restaurantTaxes), where('active', '==', true));
		const querySnapshot = await getDocs(q);
		return querySnapshotToArray(querySnapshot) || [];
	}
	catch (error) {
		console.error('Error getting restaurant tax policies', error);
		return [];
	}
}
